import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
function lazyLoad(view) {
  return () => import(`@/module/admin/${view}/${view}.vue`)
}
export default [

  {path: '/jobseekerList', component: lazyLoad('jobseekerList')},
  {path: '/admin/login', component: lazyLoad('login')},
  {path: '/admin', component: lazyLoad('login')},
  { path:'/viewkeyskills',component: lazyLoad('viewskills')},
  { path:'/createkeyskills',component: lazyLoad('createKeyskill')},
  { path: '/profileView', component: lazyLoad('profileView') },
  { path: '/courseAppeal', component: lazyLoad('courseAppeal') },
  { path: '/profileViewAppeal/:id', component: lazyLoad('profileViewAppeal') },

  { path: '/pendingEmployer', component: lazyLoad('pendingEmployer') },
  { path: '/approvedEmployer', component: lazyLoad('approvedEmployer') },
  { path: '/deniedEmployer', component: lazyLoad('deniedEmployer') },
  {path: '/admin/add', component: lazyLoad('addAdmin')},
  { path: '/sidebar', component: lazyLoad('sideMenubar') },
  { path: '/jobseekerSearch', component: lazyLoad('jobseekerSearch') },
  { path: '/employerSearch', component: lazyLoad('employerSearch') },
  { path: '/postedJobSearch', component: lazyLoad('postedJobSearch') },
  { path: '/adminStatistics', component: lazyLoad('adminStatistics') },
  { path: '/assessmentList', component: lazyLoad('assessmentList') },
  { path: '/createAssessment', component: lazyLoad('createAssessment') },
  { path: '/adminReport', component: lazyLoad('chartDashboard') },
  { path: '/jobseekerReport', component: lazyLoad('jobseekerReport') },
  { path: '/employerReport', component: lazyLoad('employerReport') },
  { path: '/stateReport', component: lazyLoad('stateReport') },
  { path: '/industryReport', component: lazyLoad('industryReport') },
  { path: '/jobCategoryReport', component: lazyLoad('jobCategoryReport') },
  { path: '/employmentTypeReport', component: lazyLoad('employmentTypeReport') },
  { path: '/positionReport', component: lazyLoad('positionReport') },
  { path: '/vacancyReport', component: lazyLoad('vacancyReport') },
  { path: '/exportReports', component: lazyLoad('exportReports') },
  { path: '/viewAssessment', component: lazyLoad('viewAssessment') },
  { path: '/deActivatedEmployer', component: lazyLoad('deActiveEmployers') },
  { path: '/sendBulkEmail', component: lazyLoad('sendBulkEmail') },
  { path:'/advertisementList',component: lazyLoad('advertisementList')},

]